export default "__VITE_ASSET__f27db985__"